export var RouletteDozen;
(function (RouletteDozen) {
    RouletteDozen[RouletteDozen["FIRST"] = 1] = "FIRST";
    RouletteDozen[RouletteDozen["SECOND"] = 2] = "SECOND";
    RouletteDozen[RouletteDozen["THIRD"] = 3] = "THIRD";
})(RouletteDozen || (RouletteDozen = {}));
